import { CxEvent } from '@spartacus/core'

export class AnalyticsEvent extends CxEvent {

  static readonly type = 'AnalyticsEvent'
  event = ''
  eventCategory = ''
  eventAction = ''
  eventLabel = ''

  constructor (event = '', eventCategory = '', eventAction = '', eventLabel = '') {
    super()
    this.event = event
    this.eventCategory = eventCategory
    this.eventAction = eventAction
    this.eventLabel = eventLabel
  }
}
